import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  max-width: 100%;
  overflow: hidden;
`;
